<template>
    <div class="page">
        <div class="page-header">
            <!-- <div class="container"> -->
                <h1 class="pl-5 title text-light">Política de Privacidad</h1>
            <!-- </div> -->
        </div>
        <main>
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-10 mx-auto py-4">

                        <p>Siguiendo los principios de licitud, lealtad y transparencia, ponemos a su disposición la
                            presente versión extendida de nuestra Política de Privacidad:</p>

                        <h5> 1. ¿Quién es el responsable del Tratamiento?</h5>
                        <p>
                            Nombre: <a href="https://viajescemo.com" target="_blank">VIAJES CEMO SA</a> <br>
                            CIF: A04006706<br>
                            Domicilio: Avenida de las Gaviotas 12-14, 04740, Roquetas de Mar, Almería, España.<br>
                            Teléfono: (+34) 950627019<br>
                            E-mail: roquetas@viajescemo.com</p>

                        <h5>2. ¿Con qué propósito recabamos su información personal? </h5>
                        <p> Tratamos la información que nos facilita con las siguientes:</p>
                        <p> - Finalidades Principales: </p>
                        <ol>
                            <li>Información sobre nuestros servicios. Atención de llamadas, respuestas a correos
                                electrónicos o mensajes de texto (SMS, WhatsApp y/o Telegram); así como consultas
                                efectuadas mediante formularios, sesiones de chats, y otras funcionalidades de nuestra
                                web.
                            </li>
                            <li>Gestión del servicio turístico contratado, así como su seguimiento, documentación y
                                facturación. </li>
                            <li>Gestionar la utilización del “área de clientes” de nuestra web por personas autorizadas
                                al efecto.</li>
                            <li>Cumplimiento de obligaciones legales, contables, tributarias y administrativas.</li>
                        </ol>

                        <p>- Finalidades Secundarias:</p>
                        <ol>
                            <li>Gestionar el envío de publicidad de productos y servicios de VIAJES CEMO, SA, por todos
                                los canales disponibles (por ejemplo, SMS, WhatsApp, Twitter, ...).
                            </li>
                            <li>Gestión de candidaturas en la selección de personal y de la relación con los interesados
                                en tanto candidatos.
                            </li>
                        </ol>

                        <h5> 3. ¿Qué categorías de datos tratamos?</h5>
                        <p> Atendiendo a las finalidades antes mencionadas, VIAJES CEMO, SA, tratará todas o parte
                            de las siguientes categorías de datos:</p>
                        <p> <strong>- Datos identificativos:</strong> nombre, apellidos, dirección postal, dirección de
                            correo electrónico,
                            código postal, teléfono.</p>
                        <p> <strong> - Características personales:</strong> estado civil, fecha de nacimiento, lugar de
                            nacimiento, sexo,
                            nacionalidad, lengua materna, características físicas o antropométricas.</p>
                        <p><strong> - Circunstancias sociales:</strong> aficiones y estilo de vida, pertenencia a clubes
                            y asociaciones, licencias, permisos o autorizaciones.</p>
                        <p><strong>- Datos de tráfico y localización.</strong></p>
                        <p><strong> - Metadatos de comunicaciones electrónicas.</strong></p>
                        <p><strong> - Datos económicos, o financieros, bancarios.</strong></p>
                        <p><strong> - Datos de seguros.</strong></p>
                        <p><strong> - Datos académicos y profesionales:</strong> formación/titulaciones, historial de
                            estudiante, experiencia profesional, pertenencia a colegios o asociaciones profesionales, en
                            el caso de los procesos
                            de selección.</p>
                        <p> Los datos personales solicitados son obligatorios, de tal forma que la negativa a
                            suministrarlos podría suponer la imposibilidad de cumplir con las finalidades paras la que
                            son tratados.
                        </p>
                        <p> Usted es garante que los datos aportados son verdaderos, exactos, completos y actualizados,
                            siendo responsable de cualquier daño o perjuicio, directo o indirecto, que pudiera
                            ocasionarse
                            como consecuencia del incumplimiento de tal obligación. En caso de que nos facilite datos de
                            terceros, deberá contar con el consentimiento de estos comprometiéndose a trasladarle la
                            presente información eximiendo a VIAJES CEMO, SA, de cualquier responsabilidad en este
                            sentido.
                            No obstante, VIAJES CEMO, SA, podrá llevar a cabo las verificaciones para constatar este
                            hecho, adoptando las medidas de diligencia debida que correspondan, conforme a la normativa
                            de
                            protección de datos.</p>

                        <h5>4. ¿Cuál es la legitimación para el tratamiento de la información personal?</h5>
                        <p> Tratamos sus datos según las siguientes bases legales:</p>
                        <ol class="list-latin-letter">
                            <li>
                                <p>El consentimiento prestado por usted de forma expresa, libre e inequívoca tras haber
                                    sido
                                    informado pormenorizadamente de la/s finalidad/es por VIAJES CEMO, SA.</p>
                                <P>Recuerde que los datos que nos facilita y/o le solicitamos son adecuados, pertinentes
                                    y
                                    estrictamente necesarios y que, en ningún caso, está obligado a ello; y que, su no
                                    comunicación,
                                    podrá afectar el cumplimiento de la/s finalidad/es perseguidas</P>
                            </li>
                            <li>
                                <P>La preparación y/o ejecución de la relación contractual entre usted y VIAJES CEMO,
                                    SA.</P>
                            </li>
                            <li>
                                <P> Interés legítimo de VIAJES CEMO, SA, o de un tercero para proporcionar y mejorar los
                                    servicios contratados, para administrar la relación con los titulares de los datos,
                                    para acciones de marketing y ejercer derechos y gestionar las responsabilidades
                                    derivados
                                    de la actividad de VIAJES CEMO, SA.</P>
                            </li>
                            <li>
                                <P>Cuando nos basamos en intereses legítimos como base legal para tratar su información
                                    personal, equilibramos esos intereses con sus intereses, derechos y libertades
                                    fundamentales.
                                    Para obtener más información sobre cómo se realizó este ejercicio de equilibrio.</P>
                            </li>
                            <li>Cumplimiento de obligaciones legales por parte de VIAJES CEMO, SA.</li>
                        </ol>

                        <h5>5. ¿A quién podemos comunicar su información personal?</h5>
                        <p> No se cederán datos a terceros, salvo autorización expresa u obligación legal. Además, para
                            alcanzar la/s finalidade/s arriba/s indicada/s, puede resultar necesario, e inclusive
                            obligatorio, que sus datos tengan que ser comunicados a los diferentes proveedores, tales
                            como compañías aéreas, navieras, hoteles y otros proveedores de servicios, quienes vendrán
                            obligados a utilizar sus datos, única y exclusivamente, para dar cumplimiento a las
                            obligaciones
                            asumidas por VIAJES CEMO, SA.</p>
                        <p> Estos proveedores, dependiendo del país de destino de su viaje, podrán estar ubicados en
                            terceros países para los que sea necesario realizar una transferencia internacional de
                            datos.</p>
                        <p> En todos los casos, VIAJES CEMO, SA, asume la responsabilidad por la información personal
                            que nos facilite. Por ello solicitamos a aquellas empresas con los que compartimos su
                            información personal que apliquen el mismo grado de protección de la información que
                            nosotros.</p>
                        <p> Asimismo, su información personal estará a disposición de las Administraciones públicas,
                            Jueces y Tribunales, para la atención de las posibles responsabilidades nacidas del
                            tratamiento de
                            sus datos personales.</p>

                        <h5>6. Transferencias Internacionales</h5>
                        <p>Algunas de los proveedores/entidades a las que se podrán ceder sus datos para el
                            cumplimiento de la/s finalidad/es indicada/s pueden estar ubicadas en terceros países donde
                            la legislación
                            exija un nivel de protección de los datos personales equivalente al del EEE o no. En este
                            último
                            caso, nos aseguraremos de que, toda transferencia de su información personal que realicemos
                            nosotros o aquellos terceros con los que la compartimos, así como la forma en que
                            gestionamos la misma,
                            cumplan con la legislación vigente en cada momento, así como con los requisitos establecidos
                            por la Agencia Española de Protección de Datos y el Supervisor Europeo de Protección de
                            Datos
                            (SEPD).</p>
                        <!-- <p>Empresa: Google LLC.</p>
                        <p>Nacionalidad: estadounidense. <br>
                            Domicilio: Plaza Pablo Ruiz Picasso, I, 28020, Madrid, España. <br>
                            Tratamiento: G-Suite, conjunto de soluciones ofimáticas a través de las cuales el
                            Responsable
                            del Tratamiento almacena y edita archivos con datos personales y recibe y envía
                            comunicaciones. <br>
                            Política de privacidad: https://policies.google.com/privacy <br>
                            Garantía/s de adecuación que aporta:
                            Adhesión al marco del Escudo de Privacidad
                            (https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/eu-us-privacy-shield_es)
                        </p> -->
                        <p>La información personal que recabamos se almacena en España, aunque su información personal
                            se haya recabado en el país en el que usted reside y ser este ajeno al EEE.</p>
                        <p>Aquellos terceros con los que compartimos su información personal pueden gestionar o
                            transferir su información personal fuera de España y del EEE hacia otros países en los que
                            poseen
                            instalaciones.</p>
                        <p>Cumpliendo en este caso con los requisitos establecidos por la Agencia Española de
                            Protección de Datos y la Unión Europea nos aseguraremos de que tanto toda transferencia de
                            su información
                            personal que realicemos nosotros o aquellos terceros con los que compartimos su información
                            personal, como la forma en que gestionamos su información personal, cumplan con la
                            legislación que nos sea de aplicación.</p>
                        <p> De todos modos, la transferencia, el almacenamiento y la gestión de su información personal
                            por nuestra parte se regirán siempre por la presente Política de Privacidad.</p>

                        <h5>7. ¿Cuáles son sus derechos?</h5>
                        <p>En tanto titular de datos personales tratados/utilizados por VIAJES CEMO, SA, usted tiene los
                            siguientes derechos:</p>
                        <ol>
                            <li>Derecho a solicitar el acceso a sus datos personales</li>
                            <li>Derecho de rectificación de los datos erróneos o inexactos</li>
                            <li>Derecho de supresión de sus datos personales</li>
                            <li>Derecho de oposición al tratamiento de sus datos personales</li>
                            <li>Derecho a solicitar la limitación del tratamiento de sus datos personales</li>
                            <li>Derecho a la portabilidad de sus datos personales (en caso de resultar aplicable)</li>
                            <li>Derecho a la transparencia en la información recibida</li>
                            <li>Derecho a no ser objeto a decisiones individuales automatizadas</li>
                            <li>Derecho a revocar el consentimiento otorgado para el tratamiento de sus datos personales
                            </li>
                            <li>Derecho a la conservación de sus datos</li>
                            <li>Derecho a formular reclamaciones ante la Agencia Española de Protección de Datos cuando
                                considere que sus derechos no han sido respetados</li>
                        </ol>

                        <h5>8. ¿Cómo puede ejercer sus derechos?</h5>
                        <p> Podrá ejercer sus derechos de protección de datos personales dirigiendo una comunicación por
                            escrito al domicilio de VIAJES CEMO, SA, indicado más arriba o a la siguiente dirección de
                            correo: roquetas@viajescemo.com, adjuntado fotocopia de su DNI/pasaporte/tarjeta de
                            extranjero o documento equivalente en vigor.</p>
                        <p> Asimismo, dispone de modelos, formularios y más información sobre sus derechos en la pagina
                            web de la Agencia Española de Protección de Datos: www.agpd.es.</p>

                        <h5> 9. ¿Puede retirar el consentimiento?</h5>
                        <p> Usted siempre tiene la posibilidad y el derecho a retirar el consentimiento para cualquier
                            finalidad específica otorgada en su momento, sin que ello afecte a la licitud del
                            tratamiento
                            basado en el consentimiento previo a su retirada o al que se efectúe conforme otra base o
                            fundamento legal.</p>

                        <h5>10. ¿De dónde provienen sus datos personales?</h5>
                        <p> Los datos que utilizamos/tratamos en VIAJES CEMO, SA, nos han sido proporcionados por usted
                            y/o obtenidos con su autorización para la/s finalidad/es descritas.</p>


                        <h5>11. ¿Dónde puede reclamar en el caso de que considere que no se tratan sus datos
                            correctamente?</h5>
                        <p> Si considera que sus datos no son tratados correctamente por VIAJES CEMO, SA, puede dirigir
                            sus reclamaciones al correo: roquetas@viajescemo.com o a la autoridad de protección de datos que
                            corresponda, siendo la AEPD la indicada en el territorio nacional: <a
                                href="http://www.agdp.es" target="_blank" rel="noopener noreferrer">www.agpd.es</a>
                        </p>

                        <h5>12. ¿Por cuánto tiempo almacenamos su información personal?</h5>
                        <p>Solo almacenamos su información personal en la medida en que la necesitamos a fin de poder
                            utilizarla conforme la/s finalidad/es por la/s que fue/ron recabada/s, y según la base
                            jurídica del tratamiento.</p>

                        <p> El plazo máximo de conservación será de 5 años desde la finalización de la relación jurídica
                            con el titular de los datos personales. No obstante, se aplicarán los siguientes plazos
                            específicos de conservación:</p>

                        <p>• Información sobre nuestros servicios: hasta la resolución de las solicitudes de
                            información.</p>

                        <p>• Gestión de candidaturas: 2 años desde que se remita el CV a VIAJES CEMO, SA.</p>

                        <p>• Gestión de suscripción al “área de clientes” de la web: 3 años desde el último inicio de
                            sesión, o hasta que manifieste su voluntad de no continuar suscrito (lo que suceda antes).
                        </p>

                        <p>Mantendremos su información personal mientras usted no ejerza los derechos de supresión,
                            cancelación y/o limitación del tratamiento de sus datos. En estos casos, conservaremos la
                            información debidamente bloqueada, sin darle ningún uso, mientras pueda ser necesaria para
                            el  ejercicio o defensa de reclamaciones o pueda derivarse algún tipo de responsabilidad
                            judicial, legal o contractual de su tratamiento, que deba ser atendida y para lo cual sea necesaria su
                            recuperación.</p>


                        <h5>13. ¿Cómo protegemos su información personal?</h5>
                        <p>- A través de las medidas técnicas y organizativas adecuadas para evitar su alteración,
                            pérdida, y/o tratamientos o accesos no autorizados, tal como exige la normativa, si bien la seguridad
                            absoluta no existe.</p>

                        <p> - Nos aseguramos de que nuestros empleados y colaboradores se encuentren debidamente
                            capacitados
                            para proteger su información personal.</p>

                        <p> - Nuestros procedimientos indican que es posible que le solicitemos prueba de identidad
                            antes de compartir su información personal con usted.</p>

                        <p>- Conforme a nuestra garantía de seguridad y confidencialidad, estamos especialmente
                            interesados en ofrecerle el más alto nivel de seguridad y proteger la confidencialidad de la información
                            personal que nos aporta. Por ello, las transacciones comerciales son realizadas en un
                            entorno de servidor seguro bajo protocolo SSL (Secure Socket Layer).</p>

                        <h5>14. ¿Cómo se tratan los datos de menores de edad?</h5>
                        <p>La página web de VIAJES CEMO, SA, (www.viajescemo.com), las aplicaciones y los productos
                            normalmente no están dirigidos a los menores de edad. Aunque en alguna ocasión podemos
                            realizar alguna campaña en las que los menores pueden mostrar su interés. No obstante, no recabamos
                            información personal alguna de menores deliberadamente, si no es con la autorización del
                            padre/madre o tutor.</p>

                        <p>Si usted es menor de edad, por favor no intente registrarse como usuario de nuestros sitios
                            web, aplicaciones o productos. Si descubrimos que por error hemos obtenido información personal
                            de un menor, eliminaremos dicha información lo antes posible.</p>

                        <h5>15. Cookies y tecnologías similares</h5>
                        <p>Tanto nosotros, como algunos de nuestros proveedores, utilizamos Cookies y tecnologías
                            similares para almacenar y administrar las preferencias de los Usuarios, enviar publicidad adaptada,
                            habilitar contenido y recolectar datos analíticos y de uso, por ejemplo.</p>
                        <p> La utilización de Cookies y otras tecnologías de rastreo se encuentra estandarizada en
                            muchos sitios web y aplicaciones mediante las cuales se recopila información sobre actividades en
                            línea de los usuarios utilizando aplicaciones, sitios web u otros servicios.</p>
                        <p>La Política de Cookies de este Sitio Web puede consultarse
                            íntegramente <router-link to="/cookies" class="pr-3">pinchando aquí.</router-link></p>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

export default {
    name: 'cookies',

    components: {
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

        //iconoStd(std) {
            //return this.estados[std];
        //}
    }
}
</script>